export default __webpack_public_path__ + "static/media/sendgrid.f0018b37.svg";